import { Col, Row } from "../components/Grid/";

import ContentBlock from "../components/ContentBlock";
import PropTypes from "prop-types";
import React from "react";
import TextSection from "../components/TextSection";
import Video from "../components/Video";
import injectSheet from "react-jss";
import tutorialsVideos from "../content/tutorialsVideos";

const styles = () => ({
  page: {
    height: "100vh",
    // Mobile portrait
    "@media (min-width: 320px) and (max-width: 667px)": {
      height: "150vh"
    },
    // Mobile landscape and ipad
    "@media (min-width: 568px) and (max-width: 823px)": {
      height: "250vh"
    },
    // Ipad portrait
    "@media (min-width: 768px) and (max-width: 769px)": {
      height: "150vh"
    },
    // Ipad pro portrait
    "@media (min-width: 1024px) and (max-width: 1025px)": {
      height: "80vh"
    }
  },
  container: {
    width: "100%",
    height: "100%"
  },
  notMobile: {
    "@media (max-width: 823px)": {
      display: "none"
    }
  },
  mobile: {
    width: "100%",
    height: "100%",
    "@media (min-width: 824px)": {
      display: "none"
    }
  },
  pageTitle: {
    fontSize: "5.4rem",
    paddingLeft: "5rem",
    fontWeight: 100,
    marginTop: "1rem",
    marginBottom: "2rem",
    "@media (max-width: 823px)": {
      fontSize: "3rem",
      padding: 0,
      textAlign: "center",
      margin: 0
    }
  },
  videoDescription: {
    fontSize: "1.3rem",
    color: "#444",
    maxWidth: "40vw",
    marginTop: "1rem",
    "@media (max-width: 823px)": {
      marginBottom: "1rem",
      maxWidth: "80vw"
    }
  },
  videoTitle: {
    fontSize: "30px",
    marginBottom: "1rem",
    "@media (max-width: 823px)": {
      fontSize: "2rem",
      padding: 0,
      textAlign: "center"
    }
  },
  listContainer: {
    height: "50vh",
    borderLeft: "solid 1px #bbb",
    maxWidth: "360px",
    overflowY: "scroll",
    overflowX: "hidden",
    marginLeft: "30px",
    "@media (max-width: 823px)": {
      border: "none",
      padding: 0,
      margin: 0,
      height: "70vh"
    }
  },
  listLinks: {
    color: "#666",
    textDecoration: "none",
    verticalAlign: "middle",
    textAlign: "left"
  },
  listItems: {
    display: "flex",
    alignItems: "center",
    padding: "0.75rem",
    borderBottom: "solid 1px #d2d7de",
    "@media (max-width: 823px)": {
      paddingLeft: 0,
      marginLeft: 0
    }
  },
  thumbnails: {
    paddingRight: "1.125rem",
    maxWidth: "84px"
  },
  video: {
    width: "45vw",
    height: "35vh",
    "@media (max-width: 823px)": {
      display: "none"
    },
    // Ipad pro portrait
    "@media (max-width: 1024px) and (max-height: 1366px)": {
      height: "300px"
    }
  },
  videoMobile: {
    width: "90vw",
    height: "28vh",
    "@media (min-width: 667px) and (max-width: 823px)": {
      height: "90vh"
    },
    // Iphone 5 landscape
    "@media (min-width: 568px) and (max-width: 640px)": {
      height: "90vh"
    },
    "@media (min-width: 767px) and (max-width: 769px)": {
      height: "40vh"
    },
    "@media (min-width: 824px)": {
      display: "none"
    }
  }
});

const TutorialsPage = ({ classes, location }) => {
  const videoId =
    location.search === ""
      ? Object.keys(tutorialsVideos).map(v => tutorialsVideos[v])[0].id
      : location.search.split("=")[1];
  return (
    <ContentBlock className={classes.page}>
      <div className={classes.container}>
        <TextSection className={classes.pageTitle}>Tutorials</TextSection>
        <br />
        <div className={classes.notMobile}>
          <Row center>
            <Col>
              <TextSection className={classes.videoTitle}>
                {tutorialsVideos[videoId].title}
              </TextSection>
              <Video
                className={classes.video}
                src={`//www.youtube.com/embed/${
                  tutorialsVideos[videoId].id
                }?rel=0&amp;showinfo=0`}
              />
              <div className={classes.videoDescription}>
                {tutorialsVideos[videoId].description}
              </div>
            </Col>
            <Col center>
              <div className={classes.listContainer}>
                <ul>
                  {Object.keys(tutorialsVideos)
                    .map(v => tutorialsVideos[v])
                    .map(video => (
                      <li className={classes.listItems} key={video.id}>
                        <a
                          className={classes.listLinks}
                          href={`/tutorials/index.html?video=${video.id}`}
                        >
                          <img
                            className={classes.thumbnails}
                            alt="Video Thumbmail"
                            src={`//img.youtube.com/vi/${
                              video.id
                            }/mqdefault.jpg`}
                          />
                          {video.title}
                        </a>
                      </li>
                    ))}
                </ul>
              </div>
            </Col>
          </Row>
        </div>
        <div className={classes.mobile}>
          <Col center middle>
            <TextSection className={classes.videoTitle}>
              {tutorialsVideos[videoId].title}
            </TextSection>
            <Video
              className={classes.videoMobile}
              src={`//www.youtube.com/embed/${
                tutorialsVideos[videoId].id
              }?rel=0&amp;showinfo=0`}
            />
            <div className={classes.videoDescription}>
              {tutorialsVideos[videoId].description}
            </div>
            <div className={classes.listContainer}>
              <ul>
                {Object.keys(tutorialsVideos)
                  .map(v => tutorialsVideos[v])
                  .map(video => (
                    <li className={classes.listItems} key={video.id}>
                      <a
                        className={classes.listLinks}
                        href={`?video=${video.id}`}
                      >
                        <img
                          className={classes.thumbnails}
                          alt="Video Thumbmail"
                          src={`//img.youtube.com/vi/${video.id}/mqdefault.jpg`}
                        />
                        {video.title}
                      </a>
                    </li>
                  ))}
              </ul>
            </div>
          </Col>
        </div>
      </div>
    </ContentBlock>
  );
};

TutorialsPage.propTypes = {
  classes: PropTypes.object,
  location: PropTypes.object
};

export default injectSheet(styles)(TutorialsPage);



// WEBPACK FOOTER //
// ./src/pages/tutorials.jsx